import { useStaticQuery, graphql } from "gatsby"

export const useArticlesData = () => {
  const data = useStaticQuery(
    graphql`
      query AllArticlesQuery {
        allPrismicArticle(
          filter: { id: { ne: "7e040f53-1d89-5061-b16f-7f8d84e8d54a" } }
          sort: { fields: first_publication_date, order: DESC }
        ) {
          edges {
            node {
              first_publication_date(fromNow: true)
              uid
              data {
                type
                title {
                  text
                }
                summary {
                  text
                }
                cover {
                  fluid {
                    src
                  }
                }
                published(fromNow: true)
              }
            }
          }
        }
      }
    `
  )
  return data.allPrismicArticle.edges
}
